import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs'
import { map } from 'rxjs/operators'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import * as localForage from "localforage";
import { Utility } from '../../common/services/utility.service';
import { saveAs } from 'file-saver';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpProvider {
  isLoading = false;
  data: any;
  token: any;
  username: any;

  apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = environment.apiUrl;
  }

  get<T>(url: string, params?: HttpParams | { [param: string]: any | any[]; }, options?: { showloader?: boolean, showerrormessage?: boolean, headers?: HttpHeaders, cachestorage?: boolean }): Observable<any> {
    //url = this.apiUrl + url;
    if (options?.cachestorage) {
      if (sessionStorage.getItem(url)) {
        return new Observable(observer => {
          return from(localForage.getItem(url)).subscribe(observer);
        });
      }
      else {
        let _params = Utility.GetParams(params);
        return this.httpClient.get<T>(url, { params: _params, headers: this.getHttpHeaders(options?.headers, options?.showloader, options?.showerrormessage) }).pipe(
          map(data => { sessionStorage.setItem(url, url); localForage.setItem(url, data) })
        );
      }
    }
    else {
      let _params = Utility.GetParams(params);
      return this.httpClient.get<T[]>(url, { params: _params, headers: this.getHttpHeaders(options?.headers, options?.showloader, options?.showerrormessage) })
    }
  }

  post<T>(url: string, data: any, options?: { queryparams?: | { [param: string]: any | any[]; }, showloader?: boolean, showerrormessage?: boolean, headers?: HttpHeaders, cachestorage?: boolean }) {
    let _params = Utility.GetParams(options?.queryparams);
    return this.httpClient.post<T>(url, data, { params: _params, headers: this.getHttpHeaders(options?.headers, options?.showloader, options?.showerrormessage) });
  }

  getFile<T>(url: string, data: any, options?: { params?: | { [param: string]: string | string[]; }, downLoadFile?: boolean, fileName?: string, extension?: string, showloader?: boolean, showerrormessage?: boolean, headers?: HttpHeaders, cachestorage?: boolean }) {
    let _params = Utility.GetParams(options?.params);
    if (options?.downLoadFile === true) {
      this.httpClient.post<T>(url, data, { params: _params, responseType: 'blob' as 'json', headers: this.getHttpHeaders(options?.headers, options?.showloader, options?.showerrormessage) }).subscribe((blob: any) => {
        saveAs(blob, options?.fileName + '.' + options?.extension);
      });
    }
    else
      return this.httpClient.post<T>(url, data, { params: _params, responseType: 'blob' as 'json', headers: this.getHttpHeaders(options?.headers, options?.showloader, options?.showerrormessage) });
  }

  put<T>(url: string, data: any, options?: { showloader?: boolean, showerrormessage?: boolean, params?: | { [param: string]: any | any[]; }, headers?: HttpHeaders, cachestorage?: boolean }) {
    return this.httpClient.put<T>(url, data, { params: options?.params, headers: this.getHttpHeaders(options?.headers, options?.showloader, options?.showerrormessage) });
  }

  delete<T>(url: string, options?: { showloader?: boolean, showerrormessage?: boolean, params?: | { [param: string]: any | any[]; }, headers?: HttpHeaders, cachestorage?: boolean }) {
    return this.httpClient.delete<T>(url, { params: options?.params, headers: this.getHttpHeaders(options?.headers, options?.showloader, options?.showerrormessage) });
  }

   private getHttpHeaders(headers: HttpHeaders, showloader: boolean = true, showerrormessage: boolean = true): HttpHeaders {
    if (!headers) { headers = new HttpHeaders(); }
    let returnheaders = headers.append("showloader", showloader ? "1" : "0").append("showerrormessage", showerrormessage ? "1" : "0").append("apiRequest", "1");;
    return returnheaders;
  }
  // protected get(uri: string, params?: any): Observable<any> {
  //   return this.httpClient.get(this.apiUrl + uri, { params: params });
  // }

  // protected getById(uri: string, id: string | number): Observable<any> {
  //   return this.httpClient.get(this.apiUrl + uri + '/' + id);
  // }

  // protected post(uri: string, params: any): Observable<any> {
  //   return this.httpClient.post(this.apiUrl + uri, params);
  // }

  // protected put(uri: string, params: any): Observable<any> {
  //   return this.httpClient.put(this.apiUrl + uri, params);
  // }

  // protected patch(uri: string, params: any): Observable<any> {
  //   return this.httpClient.patch(this.apiUrl + uri, params);
  // }

  // protected delete(uri: any, params?: any): Observable<any> {
  //   return this.httpClient.delete(this.apiUrl + uri);
  // }

  // protected getBlob(uri: string, params?: any): Observable<HttpResponse<Blob>> {
  //   return this.http.get(this.apiUrl + uri, {
  //     params,
  //     responseType: 'blob',
  //     observe: 'response',
  //   });
  // }
}
